<script lang="ts">
  import Button from '$components/reusable/Button.svelte';
  import UserIcon from '$icons/UserIcon.svelte';
  import { createQuery } from '@tanstack/svelte-query';
  import { client } from '$lib/api/Client';
  import { page } from '$app/stores';
  import HackathonProject from '$lib/components/reusable/projects/HackathonProject.svelte';
  import type { PageData } from './$types';
  import ArrowRight from '$icons/arrows/ArrowRight.svelte';
  import { goto } from '$app/navigation';
  import { base64UrlDecode } from '$utils';
  import HackathonProjectSkeleton from '$lib/components/reusable/projects/HackathonProjectSkeleton.svelte';
  import { ProjectType } from '$shared/lib';

  export let data: PageData;

  const projectQuery = createQuery({
    queryKey: ['project', $page.params.slug],
    queryFn: () =>
      client.projects.getProject({ slug: $page.params.slug, type: ProjectType.HACKATHON }),
  });

  $: previous = $page.url.searchParams.get('previous');
  $: decodedPrevious = previous ? base64UrlDecode(previous) : null;
</script>

{#if decodedPrevious}
  <Button tertiary class="mb-6" on:click={() => goto(decodedPrevious)}>
    <ArrowRight class="text-gray-dark-9  rotate-180" />
    Go back
  </Button>
{/if}
{#if $projectQuery.isSuccess && $projectQuery.data.projectType === ProjectType.HACKATHON}
  <HackathonProject
    project={$projectQuery.data.project}
    user={data.user}
    hackathon={data.hackathon}
    queryClient={data.queryClient}
  />
{:else if $projectQuery.isLoading}
  <HackathonProjectSkeleton />
{:else}
  <div class="text-gray-dark-12 flex h-96 flex-col items-center justify-center">
    <UserIcon class="!h-8 !w-8" />
    <h2 class="mt-xl mb-1 text-sm">Project Not Found!</h2>
    <p class="text-center">
      Oops, looks like we don't have a record of that project.<br />
    </p>
    <p>Click below to search for other projects.</p>
    <Button secondary class="mt-6" href="/projects/explore">Explore projects</Button>
  </div>
{/if}
